// extracted by mini-css-extract-plugin
export default {"submit":"pLD95phC4zQdFA3rsKnE","submitWrapper":"H1dgip1KloK281tc5Lku","submitError":"kOibx4sx5JSxqgWnTPHK"};